module.exports = __webpack_public_path__ + "img/chalk_9.0e125194.png";